class CartDrawer extends HTMLElement {
    constructor() {
        super();

        this.addEventListener(
            "keyup",
            (evt) => evt.code === "Escape" && this.close()
        );
        this.querySelector("#CartDrawer-Overlay").addEventListener(
            "click",
            this.close.bind(this)
        );
        this.setHeaderCartIconAccessibility();
        if( this.classList.contains("is-empty") ) this.displayRandomQuote();

        this.freeShippingBar = this.querySelector("#free-shipping-bar");
    }

    setHeaderCartIconAccessibility() {
        const cartLink = document.querySelector("#cart-icon-bubble");
        cartLink.setAttribute("role", "button");
        cartLink.setAttribute("aria-haspopup", "dialog");
        cartLink.addEventListener("click", (event) => {
            event.preventDefault();
            this.open(cartLink);
        });
        cartLink.addEventListener("keydown", (event) => {
            if (event.code.toUpperCase() === "SPACE") {
                event.preventDefault();
                this.open(cartLink);
            }
        });
    }

    open(triggeredBy) {
        if (triggeredBy) this.setActiveElement(triggeredBy);

        this.querySelector('.cart-drawer__overlay').classList.remove("o-0");
        this.classList.add("active");

        this.addEventListener(
            "transitionend",
            () => {
                const containerToTrapFocusOn = this.classList.contains("is-empty")
                    ? this.querySelector(".drawer__inner-empty")
                    : document.getElementById("cart-modal");
                const focusElement =
                    this.querySelector(".drawer__inner") ||
                    this.querySelector(".drawer__close");
                trapFocus(containerToTrapFocusOn, focusElement);
            },
            { once: true }
        );
        document.body.classList.add("overflow-hidden");
        this.updateFreeShippingBar(this.calculateTotalPriceExclusion());
    }

    close() {
        this.querySelector('.cart-drawer__overlay').classList.add("o-0");
        this.classList.remove("active");
        removeTrapFocus(this.activeElement);
        document.body.classList.remove("overflow-hidden");
    }

    updateFreeShippingBar(totalPrice) {
        if (!this.freeShippingBar) return;
        const freeShippingThreshold = this.freeShippingBar.dataset.freeShippingThreshold * 100; 
        const remainingAmount = freeShippingThreshold - totalPrice;
        const progressBar = this.querySelector(".progress-bar");
        const remainingAmountElement = this.querySelector(".remaining-amount");
        const freeShippingMessageContainer = this.freeShippingBar.querySelector(".free-shipping-message");
        const freeShippingAchievedMessage = this.freeShippingBar.dataset.freeShippingMessage; 
        const cartTotalPriceExclusion = this.querySelector('.cart-total-price-exclusion');

        if (remainingAmount > 0) {
            if (remainingAmountElement) {
                remainingAmountElement.textContent = `$${Math.ceil(remainingAmount / 100)}`;
            }
            progressBar.style.width = `${(totalPrice / freeShippingThreshold) * 100}%`;
        } else {
            freeShippingAchievedMessage ? freeShippingMessageContainer.textContent = freeShippingAchievedMessage : freeShippingMessageContainer.textContent = "Congratulations! You've got free shipping."
            progressBar.style.width = "100%";
            cartTotalPriceExclusion.style.color = 'green';
        }
        cartTotalPriceExclusion.textContent = `$${(totalPrice / 100).toFixed(2)}`;
        
    }

    calculateTotalPriceExclusion() {
        const drawerCompCartItems = this.querySelectorAll('article.cart-item');
        let totalPriceExclusion = 0;

        drawerCompCartItems.forEach(item => {
            if (!item.dataset.itemExclusion) {
                const itemPrice = parseInt(item.querySelector('.price').textContent.replace('$', '').replace(',', '')) * 100;
                const itemQuantity = parseInt(item.querySelector('[name="updates[]"]').value);
                totalPriceExclusion += itemPrice * itemQuantity;
            }
        });

        return totalPriceExclusion;
    }

    setSummaryAccessibility(cartDrawerNote) {
        cartDrawerNote.setAttribute("role", "button");
        cartDrawerNote.setAttribute("aria-expanded", "false");

        if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
            cartDrawerNote.setAttribute(
                "aria-controls",
                cartDrawerNote.nextElementSibling.id
            );
        }

        cartDrawerNote.addEventListener("click", (event) => {
            event.currentTarget.setAttribute(
                "aria-expanded",
                !event.currentTarget.closest("details").hasAttribute("open")
            );
        });

        cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
    }

    renderContents(parsedState) {
        this.querySelector(".drawer__inner").classList.contains("is-empty") &&
            this.querySelector(".drawer__inner").classList.remove("is-empty");
        this.productId = parsedState.id;
        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector
            );
        });

        setTimeout(() => {
            this.querySelector("#CartDrawer-Overlay").addEventListener(
                "click",
                this.close.bind(this)
            );
            this.open();
            
            if (typeof yotpoWidgetsContainer !== 'undefined') {
                yotpoWidgetsContainer.initWidgets();
            }
        });
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: "cart-modal",
                selector: "#cart-modal",
            },
            {
                id: "cart-icon-bubble",
            },
        ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
    displayRandomQuote(){
        const quotes = this.getElementsByClassName("cart_quote");
        const size = quotes.length;
        if( size > 0 ){
            var random = Math.floor(Math.random() * size);
            quotes[random].classList.remove("dn")
        }
    }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: "cart-modal",
                section: "cart-modal",
                selector: ".drawer__inner",
            },
            {
                id: "cart-icon-bubble",
                section: "cart-icon-bubble",
                selector: ".shopify-section",
            },
        ];
    }

    renderContents(parsedState) {
        super.renderContents(parsedState);
    }

    calculateTotalPriceExclusion() {
        const drawerItemsCompCartItems = this.querySelectorAll("article.cart-item");
        let totalPriceExclusion = 0;

        drawerItemsCompCartItems.forEach(item => {
            if (!item.dataset.itemExclusion) {
                const itemPrice = parseInt(item.querySelector('.price').textContent.replace('$', '').replace(',', '')) * 100;
                const itemQuantity = parseInt(item.querySelector('[name="updates[]"]').value);
                totalPriceExclusion += itemPrice * itemQuantity;
            }
        });
        return totalPriceExclusion;
    }
}

customElements.define("cart-drawer-items", CartDrawerItems);
